import { render, staticRenderFns } from "./SeguroFianca.vue?vue&type=template&id=286db7b0&scoped=true&"
import script from "./SeguroFianca.vue?vue&type=script&lang=js&"
export * from "./SeguroFianca.vue?vue&type=script&lang=js&"
import style0 from "./SeguroFianca.vue?vue&type=style&index=0&id=286db7b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286db7b0",
  null
  
)

export default component.exports